import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../Navbar/index";
import "./portfolio.css";
import { motion } from "framer-motion";
import { TbExternalLink } from "react-icons/tb";
import SectionTitle from "../SectionTitle";
import PortFoImg1 from "../../images/portfolio_images/project-1.jpg";
import PortFoImg2 from "../../images/portfolio_images/project-2.jpg";
import PortFoImg3 from "../../images/portfolio_images/project-3.jpg";
import PortFoImg4 from "../../images/portfolio_images/project-4.jpg";
import PortFoImg5 from "../../images/portfolio_images/project-5.jpg";
import PortFoImg6 from "../../images/portfolio_images/project-6.jpg";

const Projects = () => {
  const desc =
    "A FEW RECENT DESIGN AND CODING PROJECTS. WANT TO SEE MORE? EMAIL ME.";
  const variants = {
    hidden: { opacity: 0, x: -1500, y: 0 },
    enter: { opacity: 1, x: 0, y: 0 },
    exit: { opacity: 1, x: 0, y: -200 },
  };
  const portfoitems = [
    {
      portFolio_image: PortFoImg1,
      portFohover: "HTML Template",
      portfoIcon: <TbExternalLink />,
      link: "https://sahriarovi174506.github.io/sahriar/",
      name: "html",
      id: 1,
    },
    {
      portFolio_image: PortFoImg2,
      portFohover: "React.js Template",
      portfoIcon: <TbExternalLink />,
      link: "https://shahriarovi.netlify.app/",
      name: "react",
      id: 2,
    },
    {
      portFolio_image: PortFoImg3,
      portFohover: "HTML Template",
      portfoIcon: <TbExternalLink />,
      link: "https://sahriarovi174506.github.io/evoltaTwo/",
      name: "html",
      id: 3,
    },
    {
      portFolio_image: PortFoImg4,
      portFohover: "HTML Template",
      portfoIcon: <TbExternalLink />,
      link: "https://sahriarovi174506.github.io/Cryptoros.gihub.io/",
      name: "html",
      id: 4,
    },
    {
      portFolio_image: PortFoImg5,
      portFohover: "HTML Template",
      portfoIcon: <TbExternalLink />,
      link: "https://sahriarovi174506.github.io/repo.github.io/",
      name: "html",
      id: 5,
    },
    {
      portFolio_image: PortFoImg6,
      portFohover: "HTML Template",
      portfoIcon: <TbExternalLink />,
      link: "https://sahriarovi174506.github.io/akashupate/index.html",
      name: "html",
      id: 6,
    },
  ];
  const [items, setItems] = useState(portfoitems);
  const filterItem = (getItem) => {
    // eslint-disable-next-line no-unused-vars
    const myItems = portfoitems.filter((currentEl) => {
      return currentEl.name === getItem;
    });
    setItems(myItems);
  };
  useEffect(() => {
    document.querySelectorAll(".portfoli").forEach((element) => {
      element.addEventListener("click", function () {
        if (document.querySelector(".portfoli.activate") !== null) {
          document
            .querySelector(".portfoli.activate")
            .classList.remove("activate");
        }
        this.classList.add("activate");
      });
    });
  }, []);
  return (
    <motion.div
      variants={variants}
      initial="hidden"
      animate="enter"
      exit="exit"
      transition={{ type: "linear", duration: 0.5 }}
    >
      <Navbar activeLi3={"activeLi"} />
      <section className="portfolio_area">
        <div className="container">
          <SectionTitle sectitle={"MY"} clrTtle="PORTFOLIO" secDesc={desc} />
          <div className="filterItems">
            <button
              className="portfoli activate"
              onClick={() => setItems(portfoitems)}
            >
              all
            </button>
            <button className="portfoli" onClick={() => filterItem("html")}>
              html
            </button>
            <button className="portfoli" onClick={() => filterItem("react")}>
              react
            </button>
          </div>
          <div className="portfolio_boxes">
            {items.map((portfoIitms) => {
              const { portFolio_image, portFohover, portfoIcon, link } =
                portfoIitms;
              return (
                <a href={link} title="Click to the Site" key={portfoIitms.id}>
                  <div className="portfolio_box animate_Scale">
                    <div className="portFoimg">
                      <img src={portFolio_image} alt="porfoImg" />
                    </div>
                    <div className="portfohover">
                      <div className="portHoverItms">
                        <h4>{portFohover}</h4>
                        <div className="porthoverIcon">
                          <span>{portfoIcon}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Projects;
